import { render } from "./PaneResaleOnlineType.vue?vue&type=template&id=3b95df81&scoped=true&ts=true"
import script from "./PaneResaleOnlineType.vue?vue&type=script&lang=ts"
export * from "./PaneResaleOnlineType.vue?vue&type=script&lang=ts"

import "./PaneResaleOnlineType.vue?vue&type=style&index=0&id=3b95df81&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b95df81"]])

export default __exports__